import { z } from "zod"

export const ContactGeneralInfoFormSchema = z.object({
  firstName: z
    .string()
    .min(1, { message: "First name is mandatory" })
    .max(20, "First name must not exceed 20 characters"), // AS400 constraint
  lastName: z.string().min(1, { message: "Last name is mandatory" }).max(20, "Last name must not exceed 20 characters"), // AS400 constraint
  companyDepartment: z.string().optional(),
  title: z.string().max(30, "Title must not exceed 30 characters").optional(), // AS400 constraint
  physicalLocationId: z.string().uuid({ message: "Office location is mandatory" }),
})

export const ContactPhoneFormSchema = z.object({
  number: z.string().max(25, "Phone number must not exceed 25 characters").optional(), // AS400 constraint
  type: z.enum(["Text", "Work", "Mobile", "Home", "Fax", "Other"]).optional(),
  phoneExt: z
    .string()
    .regex(/^\d*$/, "Phone extension must only contain digits")
    .max(10, "Phone extension must not exceed 10 digits")
    .optional(),
  isPreferred: z.boolean().optional(),
  contactMethodId: z.string().optional(),
})

export const ContactMethodsFormSchema = z.object({
  phones: z.array(ContactPhoneFormSchema).optional(),
  email: z
    .string()
    .email("Invalid email format")
    .max(70, "Email must not exceed 70 characters") // AS400 constraint
    .optional()
    .or(z.literal("")),
})

export const ContactLocationAddFormSchema = z.object({
  locationId: z.string(),
  roles: z.array(z.string()),
  isPrimary: z.boolean().default(false).optional(),
})

export const ContactLocationsAddFormSchema = z.object({
  locationRoles: z.array(ContactLocationAddFormSchema),
})

export const ContactLocationEditFormSchema = z.object({
  locationId: z.string(),
  currentRoles: z.array(z.string()),
  newRoles: z.array(z.string()),
})

export const ContactLocationsEditFormSchema = z.object({
  currentLocationRoles: z.array(ContactLocationEditFormSchema),
  newLocationRoles: z.array(ContactLocationAddFormSchema),
})

export const ContactAddFormSchema =
  ContactGeneralInfoFormSchema.merge(ContactMethodsFormSchema).merge(ContactLocationsAddFormSchema)

export const ContactEditFormSchema = ContactGeneralInfoFormSchema.merge(ContactMethodsFormSchema)

export type ContactGeneralInfoFormValues = z.infer<typeof ContactGeneralInfoFormSchema>

export type ContactPhoneFormValues = z.infer<typeof ContactPhoneFormSchema>

export type ContactMethodsFormValues = z.infer<typeof ContactMethodsFormSchema>

export type ContactLocationAddFormValues = z.infer<typeof ContactLocationAddFormSchema>

export type ContactLocationsAddFormValues = z.infer<typeof ContactLocationsAddFormSchema>

export type ContactLocationEditFormValues = z.infer<typeof ContactLocationEditFormSchema>

export type ContactLocationsEditFormValues = z.infer<typeof ContactLocationsEditFormSchema>

export type ContactAddFormValues = z.infer<typeof ContactAddFormSchema>

export type ContactEditFormValues = z.infer<typeof ContactEditFormSchema>
